import React from 'react';

import {
    Accessibility,
    Accessible,
    AccountBalance,
    AccountBalanceWallet,
    AccountBox,
    AccountCircle,
    Add,
    AddAlert,
    AddBox,
    AddCircle,
    AddCircleOutline,
    AddShoppingCart,
    AddToQueue,
    Airplay,
    Alarm,
    Album,
    Archive,
    ArtTrack,
    AssignmentInd,
    AssignmentLate,
    AssignmentReturn,
    AssignmentReturned,
    AssignmentTurnedIn,
    Autorenew,
    AvTimer,
    Backspace,
    Backup,
    Block,
    Book,
    Bookmark,
    BookmarkBorder,
    BrandingWatermark,
    BugReport,
    Build,
    Business,
    Cached,
    Call,
    CallEnd,
    CallMade,
    CallMerge,
    CallMissed,
    CallMissedOutgoing,
    CallReceived,
    CallSplit,
    CallToAction,
    CameraEnhance,
    CardGiftcard,
    CardMembership,
    CardTravel,
    ChangeHistory,
    Chat,
    ChatBubble,
    ChatBubbleOutline,
    CheckCircle,
    Clear,
    ClearAll,
    ClosedCaption,
    Comment,
    ContactMail,
    ContactPhone,
    Contacts,
    ContentCopy,
    Delete,
    DeleteForever,
    Description,
    DialerSip,
    Dialpad,
    Dns,
    Done,
    DoneAll,
    DonutLarge,
    DonutSmall,
    Eject,
    Email,
    Equalizer,
    Error,
    ErrorOutline,
    EuroSymbol,
    Event,
    EventSeat,
    ExitToApp,
    Explicit,
    Explore,
    Extension,
    Face,
    FastForward,
    FastRewind,
    Favorite,
    FavoriteBorder,
    FeaturedPlayList,
    FeaturedVideo,
    Feedback,
    FiberDvr,
    FiberManualRecord,
    FiberNew,
    FiberPin,
    FiberSmartRecord,
    FindInPage,
    FindReplace,
    Fingerprint,
    FlightLand,
    FlightTakeoff,
    FlipToBack,
    FlipToFront,
    Forum,
    Forward10,
    Forward30,
    Forward5,
    Games,
    Gavel,
    GetApp,
    Gif,
    Grade,
    GroupWork,
    GTranslate,
    Hd,
    Hearing,
    Help,
    HelpOutline,
    HighlightOff,
    HighQuality,
    History,
    Home,
    HourglassEmpty,
    HourglassFull,
    Http,
    Https,
    ImportantDevices,
    ImportContacts,
    ImportExport,
    Info,
    InfoOutline,
    Input,
    InvertColors,
    InvertColorsOff,
    Label,
    LabelOutline,
    Language,
    Launch,
    LibraryAdd,
    LibraryBooks,
    LibraryMusic,
    LightbulbOutline,
    LineStyle,
    LineWeight,
    List,
    LiveHelp,
    LocationOff,
    LocationOn,
    Lock,
    LockOpen,
    LockOutline,
    Loop,
    Loyalty,
    MailOutline,
    MarkunreadMailbox,
    Message,
    Mic,
    MicNone,
    MicOff,
    Motorcycle,
    Movie,
    MusicVideo,
    NewReleases,
    NoSim,
    Note,
    NoteAdd,
    NotInterested,
    OfflinePin,
    Opacity,
    OpenInBrowser,
    OpenInNew,
    OpenWith,
    Pageview,
    PanTool,
    Pause,
    PauseCircleFilled,
    PauseCircleOutline,
    Payment,
    PermCameraMic,
    PermContactCalendar,
    PermDataSetting,
    PermDeviceInformation,
    PermIdentity,
    PermMedia,
    PermPhoneMsg,
    PermScanWifi,
    Pets,
    Phone,
    PhonelinkErase,
    PhonelinkLock,
    PhonelinkRing,
    PhonelinkSetup,
    PictureInPicture,
    PictureInPictureAlt,
    PlayArrow,
    PlayCircleFilled,
    PlayCircleOutline,
    PlayForWork,
    PlaylistAdd,
    PlaylistAddCheck,
    PlaylistPlay,
    Polymer,
    PortableWifiOff,
    PowerSettingsNew,
    PregnantWoman,
    PresentToAll,
    Print,
    QueryBuilder,
    QuestionAnswer,
    Queue,
    QueueMusic,
    QueuePlayNext,
    Radio,
    Receipt,
    RecentActors,
    RecordVoiceOver,
    Redeem,
    RemoveFromQueue,
    RemoveShoppingCart,
    Reorder,
    Repeat,
    RepeatOne,
    Replay,
    Replay5,
    ReportProblem,
    Restore,
    RestorePage,
    RingVolume,
    Room,
    RoundedCorner,
    Rowing,
    RssFeed,
    Schedule,
    ScreenShare,
    Search,
    Settings,
    SettingsApplications,
    SettingsBackupRestore,
    SettingsBluetooth,
    SettingsBrightness,
    SettingsCell,
    SettingsEthernet,
    SettingsInputAntenna,
    SettingsInputComponent,
    SettingsInputComposite,
    SettingsInputHdmi,
    SettingsInputSvideo,
    SettingsOverscan,
    SettingsPhone,
    SettingsPower,
    SettingsRemote,
    SettingsVoice,
    Shop,
    ShoppingBasket,
    ShoppingCart,
    ShopTwo,
    Shuffle,
    SkipNext,
    SkipPrevious,
    SlowMotionVideo,
    Snooze,
    SortByAlpha,
    SpeakerNotes,
    SpeakerNotesOff,
    SpeakerPhone,
    Spellcheck,
    Stars,
    StayCurrentLandscape,
    StayCurrentPortrait,
    StayPrimaryLandscape,
    StayPrimaryPortrait,
    Stop,
    StopScreenShare,
    Store,
    Subject,
    Subscriptions,
    Subtitles,
    SupervisorAccount,
    SurroundSound,
    SwapCalls,
    SwapHoriz,
    SwapVert,
    SwapVerticalCircle,
    SystemUpdateAlt,
    Tab,
    TabUnselected,
    Textsms,
    Theaters,
    ThreeDRotation,
    ThumbDown,
    ThumbsUpDown,
    ThumbUp,
    Timeline,
    Toc,
    Today,
    Toll,
    TouchApp,
    TrackChanges,
    Translate,
    TrendingDown,
    TrendingFlat,
    TrendingUp,
    TurnedIn,
    TurnedInNot,
    Update,
    VerifiedUser,
    VideoCall,
    Videocam,
    VideocamOff,
    VideoLabel,
    VideoLibrary,
    ViewAgenda,
    ViewArray,
    ViewCarousel,
    ViewColumn,
    ViewDay,
    ViewHeadline,
    ViewList,
    ViewModule,
    ViewQuilt,
    ViewStream,
    ViewWeek,
    Visibility,
    VisibilityOff,
    Voicemail,
    VolumeDown,
    VolumeMute,
    VolumeOff,
    VolumeUp,
    VpnKey,
    Warning,
    WatchLater,
    Web,
    WebAsset,
    Work,
    YoutubeSearchedFor,
    ZoomIn,
    ZoomOut,
} from 'material-ui-icons'


const Icons = () => (
    <div className="row">
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SlowMotionVideo />
            <p className="mt-1 mb-4">SlowMotionVideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAdd />
            <p className="mt-1 mb-4">PlaylistAdd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayCircleOutline />
            <p className="mt-1 mb-4">PlayCircleOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayCircleFilled />
            <p className="mt-1 mb-4">PlayCircleFilled</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayArrow />
            <p className="mt-1 mb-4">PlayArrow</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PauseCircleOutline />
            <p className="mt-1 mb-4">PauseCircleOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PauseCircleFilled />
            <p className="mt-1 mb-4">PauseCircleFilled</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pause />
            <p className="mt-1 mb-4">Pause</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Note />
            <p className="mt-1 mb-4">Note</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <NotInterested />
            <p className="mt-1 mb-4">NotInterested</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturned />
            <p className="mt-1 mb-4">AssignmentReturned</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentTurnedIn />
            <p className="mt-1 mb-4">AssignmentTurnedIn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Autorenew />
            <p className="mt-1 mb-4">Autorenew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Backup />
            <p className="mt-1 mb-4">Backup</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Book />
            <p className="mt-1 mb-4">Book</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Bookmark />
            <p className="mt-1 mb-4">Bookmark</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VideoLibrary />
            <p className="mt-1 mb-4">VideoLibrary</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VideoLabel />
            <p className="mt-1 mb-4">VideoLabel</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VideoCall />
            <p className="mt-1 mb-4">VideoCall</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SurroundSound />
            <p className="mt-1 mb-4">SurroundSound</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Subtitles />
            <p className="mt-1 mb-4">Subtitles</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Subscriptions />
            <p className="mt-1 mb-4">Subscriptions</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stop />
            <p className="mt-1 mb-4">Stop</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SortByAlpha />
            <p className="mt-1 mb-4">SortByAlpha</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Snooze />
            <p className="mt-1 mb-4">Snooze</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CheckCircle />
            <p className="mt-1 mb-4">CheckCircle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <WebAsset />
            <p className="mt-1 mb-4">WebAsset</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Web />
            <p className="mt-1 mb-4">Web</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VolumeUp />
            <p className="mt-1 mb-4">VolumeUp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VolumeOff />
            <p className="mt-1 mb-4">VolumeOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VolumeMute />
            <p className="mt-1 mb-4">VolumeMute</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VolumeDown />
            <p className="mt-1 mb-4">VolumeDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VideocamOff />
            <p className="mt-1 mb-4">VideocamOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Videocam />
            <p className="mt-1 mb-4">Videocam</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Delete />
            <p className="mt-1 mb-4">Delete</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DeleteForever />
            <p className="mt-1 mb-4">DeleteForever</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Description />
            <p className="mt-1 mb-4">Description</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Dns />
            <p className="mt-1 mb-4">Dns</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Done />
            <p className="mt-1 mb-4">Done</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DoneAll />
            <p className="mt-1 mb-4">DoneAll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DonutLarge />
            <p className="mt-1 mb-4">DonutLarge</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DonutSmall />
            <p className="mt-1 mb-4">DonutSmall</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Eject />
            <p className="mt-1 mb-4">Eject</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DialerSip />
            <p className="mt-1 mb-4">DialerSip</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Contacts />
            <p className="mt-1 mb-4">Contacts</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ContactPhone />
            <p className="mt-1 mb-4">ContactPhone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ContactMail />
            <p className="mt-1 mb-4">ContactMail</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Comment />
            <p className="mt-1 mb-4">Comment</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ClearAll />
            <p className="mt-1 mb-4">ClearAll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ChatBubbleOutline />
            <p className="mt-1 mb-4">ChatBubbleOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ChatBubble />
            <p className="mt-1 mb-4">ChatBubble</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Chat />
            <p className="mt-1 mb-4">Chat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallSplit />
            <p className="mt-1 mb-4">CallSplit</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallReceived />
            <p className="mt-1 mb-4">CallReceived</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallMissedOutgoing />
            <p className="mt-1 mb-4">CallMissedOutgoing</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallMissed />
            <p className="mt-1 mb-4">CallMissed</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallMerge />
            <p className="mt-1 mb-4">CallMerge</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallMade />
            <p className="mt-1 mb-4">CallMade</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallEnd />
            <p className="mt-1 mb-4">CallEnd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Call />
            <p className="mt-1 mb-4">Call</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Business />
            <p className="mt-1 mb-4">Business</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LocationOn />
            <p className="mt-1 mb-4">LocationOn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LocationOff />
            <p className="mt-1 mb-4">LocationOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LiveHelp />
            <p className="mt-1 mb-4">LiveHelp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <InvertColorsOff />
            <p className="mt-1 mb-4">InvertColorsOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ImportExport />
            <p className="mt-1 mb-4">ImportExport</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ImportContacts />
            <p className="mt-1 mb-4">ImportContacts</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Forum />
            <p className="mt-1 mb-4">Forum</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Email />
            <p className="mt-1 mb-4">Email</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Dialpad />
            <p className="mt-1 mb-4">Dialpad</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PortableWifiOff />
            <p className="mt-1 mb-4">PortableWifiOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PhonelinkSetup />
            <p className="mt-1 mb-4">PhonelinkSetup</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PhonelinkRing />
            <p className="mt-1 mb-4">PhonelinkRing</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PhonelinkLock />
            <p className="mt-1 mb-4">PhonelinkLock</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PhonelinkErase />
            <p className="mt-1 mb-4">PhonelinkErase</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Phone />
            <p className="mt-1 mb-4">Phone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <NoSim />
            <p className="mt-1 mb-4">NoSim</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Message />
            <p className="mt-1 mb-4">Message</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <MailOutline />
            <p className="mt-1 mb-4">MailOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <StayPrimaryPortrait />
            <p className="mt-1 mb-4">StayPrimaryPortrait</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <StayPrimaryLandscape />
            <p className="mt-1 mb-4">StayPrimaryLandscape</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <StayCurrentPortrait />
            <p className="mt-1 mb-4">StayCurrentPortrait</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <StayCurrentLandscape />
            <p className="mt-1 mb-4">StayCurrentLandscape</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SpeakerPhone />
            <p className="mt-1 mb-4">SpeakerPhone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ScreenShare />
            <p className="mt-1 mb-4">ScreenShare</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RssFeed />
            <p className="mt-1 mb-4">RssFeed</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RingVolume />
            <p className="mt-1 mb-4">RingVolume</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PresentToAll />
            <p className="mt-1 mb-4">PresentToAll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Lock />
            <p className="mt-1 mb-4">Lock</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LockOpen />
            <p className="mt-1 mb-4">LockOpen</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LockOutline />
            <p className="mt-1 mb-4">LockOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Loyalty />
            <p className="mt-1 mb-4">Loyalty</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VpnKey />
            <p className="mt-1 mb-4">VpnKey</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Voicemail />
            <p className="mt-1 mb-4">Voicemail</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Textsms />
            <p className="mt-1 mb-4">Textsms</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapCalls />
            <p className="mt-1 mb-4">SwapCalls</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <StopScreenShare />
            <p className="mt-1 mb-4">StopScreenShare</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenInBrowser />
            <p className="mt-1 mb-4">OpenInBrowser</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenInNew />
            <p className="mt-1 mb-4">OpenInNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenWith />
            <p className="mt-1 mb-4">OpenWith</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pageview />
            <p className="mt-1 mb-4">Pageview</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PanTool />
            <p className="mt-1 mb-4">PanTool</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Payment />
            <p className="mt-1 mb-4">Payment</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermCameraMic />
            <p className="mt-1 mb-4">PermCameraMic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermContactCalendar />
            <p className="mt-1 mb-4">PermContactCalendar</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermDataSetting />
            <p className="mt-1 mb-4">PermDataSetting</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ContentCopy />
            <p className="mt-1 mb-4">ContentCopy</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Clear />
            <p className="mt-1 mb-4">Clear</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Block />
            <p className="mt-1 mb-4">Block</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Backspace />
            <p className="mt-1 mb-4">Backspace</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Archive />
            <p className="mt-1 mb-4">Archive</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddCircleOutline />
            <p className="mt-1 mb-4">AddCircleOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddCircle />
            <p className="mt-1 mb-4">AddCircle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddBox />
            <p className="mt-1 mb-4">AddBox</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Add />
            <p className="mt-1 mb-4">Add</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Polymer />
            <p className="mt-1 mb-4">Polymer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PowerSettingsNew />
            <p className="mt-1 mb-4">PowerSettingsNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PregnantWoman />
            <p className="mt-1 mb-4">PregnantWoman</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Print />
            <p className="mt-1 mb-4">Print</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueryBuilder />
            <p className="mt-1 mb-4">QueryBuilder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QuestionAnswer />
            <p className="mt-1 mb-4">QuestionAnswer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Receipt />
            <p className="mt-1 mb-4">Receipt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecordVoiceOver />
            <p className="mt-1 mb-4">RecordVoiceOver</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Redeem />
            <p className="mt-1 mb-4">Redeem</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Schedule />
            <p className="mt-1 mb-4">Schedule</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Rowing />
            <p className="mt-1 mb-4">Rowing</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RoundedCorner />
            <p className="mt-1 mb-4">RoundedCorner</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Room />
            <p className="mt-1 mb-4">Room</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RestorePage />
            <p className="mt-1 mb-4">RestorePage</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Restore />
            <p className="mt-1 mb-4">Restore</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ReportProblem />
            <p className="mt-1 mb-4">ReportProblem</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Reorder />
            <p className="mt-1 mb-4">Reorder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveShoppingCart />
            <p className="mt-1 mb-4">RemoveShoppingCart</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Search />
            <p className="mt-1 mb-4">Search</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Settings />
            <p className="mt-1 mb-4">Settings</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsApplications />
            <p className="mt-1 mb-4">SettingsApplications</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBackupRestore />
            <p className="mt-1 mb-4">SettingsBackupRestore</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBluetooth />
            <p className="mt-1 mb-4">SettingsBluetooth</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBrightness />
            <p className="mt-1 mb-4">SettingsBrightness</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsCell />
            <p className="mt-1 mb-4">SettingsCell</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsEthernet />
            <p className="mt-1 mb-4">SettingsEthernet</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputAntenna />
            <p className="mt-1 mb-4">SettingsInputAntenna</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputComponent />
            <p className="mt-1 mb-4">SettingsInputComponent</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputComposite />
            <p className="mt-1 mb-4">SettingsInputComposite</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputHdmi />
            <p className="mt-1 mb-4">SettingsInputHdmi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputSvideo />
            <p className="mt-1 mb-4">SettingsInputSvideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsOverscan />
            <p className="mt-1 mb-4">SettingsOverscan</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsPhone />
            <p className="mt-1 mb-4">SettingsPhone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsPower />
            <p className="mt-1 mb-4">SettingsPower</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsRemote />
            <p className="mt-1 mb-4">SettingsRemote</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsVoice />
            <p className="mt-1 mb-4">SettingsVoice</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Shop />
            <p className="mt-1 mb-4">Shop</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShopTwo />
            <p className="mt-1 mb-4">ShopTwo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShoppingBasket />
            <p className="mt-1 mb-4">ShoppingBasket</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShoppingCart />
            <p className="mt-1 mb-4">ShoppingCart</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SpeakerNotes />
            <p className="mt-1 mb-4">SpeakerNotes</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SpeakerNotesOff />
            <p className="mt-1 mb-4">SpeakerNotesOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Spellcheck />
            <p className="mt-1 mb-4">Spellcheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stars />
            <p className="mt-1 mb-4">Stars</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Store />
            <p className="mt-1 mb-4">Store</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Subject />
            <p className="mt-1 mb-4">Subject</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SupervisorAccount />
            <p className="mt-1 mb-4">SupervisorAccount</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapHoriz />
            <p className="mt-1 mb-4">SwapHoriz</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapVert />
            <p className="mt-1 mb-4">SwapVert</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapVerticalCircle />
            <p className="mt-1 mb-4">SwapVerticalCircle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SystemUpdateAlt />
            <p className="mt-1 mb-4">SystemUpdateAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Tab />
            <p className="mt-1 mb-4">Tab</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TabUnselected />
            <p className="mt-1 mb-4">TabUnselected</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Theaters />
            <p className="mt-1 mb-4">Theaters</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbDown />
            <p className="mt-1 mb-4">ThumbDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbUp />
            <p className="mt-1 mb-4">ThumbUp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbsUpDown />
            <p className="mt-1 mb-4">ThumbsUpDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Timeline />
            <p className="mt-1 mb-4">Timeline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Toc />
            <p className="mt-1 mb-4">Toc</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Today />
            <p className="mt-1 mb-4">Today</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Toll />
            <p className="mt-1 mb-4">Toll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TouchApp />
            <p className="mt-1 mb-4">TouchApp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrackChanges />
            <p className="mt-1 mb-4">TrackChanges</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Translate />
            <p className="mt-1 mb-4">Translate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingDown />
            <p className="mt-1 mb-4">TrendingDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingFlat />
            <p className="mt-1 mb-4">TrendingFlat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingUp />
            <p className="mt-1 mb-4">TrendingUp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TurnedIn />
            <p className="mt-1 mb-4">TurnedIn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TurnedInNot />
            <p className="mt-1 mb-4">TurnedInNot</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Update />
            <p className="mt-1 mb-4">Update</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VerifiedUser />
            <p className="mt-1 mb-4">VerifiedUser</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewAgenda />
            <p className="mt-1 mb-4">ViewAgenda</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewArray />
            <p className="mt-1 mb-4">ViewArray</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewCarousel />
            <p className="mt-1 mb-4">ViewCarousel</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewColumn />
            <p className="mt-1 mb-4">ViewColumn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewDay />
            <p className="mt-1 mb-4">ViewDay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewHeadline />
            <p className="mt-1 mb-4">ViewHeadline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewList />
            <p className="mt-1 mb-4">ViewList</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewModule />
            <p className="mt-1 mb-4">ViewModule</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewQuilt />
            <p className="mt-1 mb-4">ViewQuilt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewStream />
            <p className="mt-1 mb-4">ViewStream</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewWeek />
            <p className="mt-1 mb-4">ViewWeek</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Visibility />
            <p className="mt-1 mb-4">Visibility</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VisibilityOff />
            <p className="mt-1 mb-4">VisibilityOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <WatchLater />
            <p className="mt-1 mb-4">WatchLater</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Work />
            <p className="mt-1 mb-4">Work</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <YoutubeSearchedFor />
            <p className="mt-1 mb-4">YoutubeSearchedFor</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ZoomIn />
            <p className="mt-1 mb-4">ZoomIn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ZoomOut />
            <p className="mt-1 mb-4">ZoomOut</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddAlert />
            <p className="mt-1 mb-4">AddAlert</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Error />
            <p className="mt-1 mb-4">Error</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ErrorOutline />
            <p className="mt-1 mb-4">ErrorOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Warning />
            <p className="mt-1 mb-4">Warning</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddToQueue />
            <p className="mt-1 mb-4">AddToQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Airplay />
            <p className="mt-1 mb-4">Airplay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Album />
            <p className="mt-1 mb-4">Album</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ArtTrack />
            <p className="mt-1 mb-4">ArtTrack</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AvTimer />
            <p className="mt-1 mb-4">AvTimer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <BrandingWatermark />
            <p className="mt-1 mb-4">BrandingWatermark</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallToAction />
            <p className="mt-1 mb-4">CallToAction</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ClosedCaption />
            <p className="mt-1 mb-4">ClosedCaption</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Equalizer />
            <p className="mt-1 mb-4">Equalizer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Explicit />
            <p className="mt-1 mb-4">Explicit</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FastForward />
            <p className="mt-1 mb-4">FastForward</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FastRewind />
            <p className="mt-1 mb-4">FastRewind</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FeaturedPlayList />
            <p className="mt-1 mb-4">FeaturedPlayList</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FeaturedVideo />
            <p className="mt-1 mb-4">FeaturedVideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberDvr />
            <p className="mt-1 mb-4">FiberDvr</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberManualRecord />
            <p className="mt-1 mb-4">FiberManualRecord</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberNew />
            <p className="mt-1 mb-4">FiberNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberPin />
            <p className="mt-1 mb-4">FiberPin</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberSmartRecord />
            <p className="mt-1 mb-4">FiberSmartRecord</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Forward10 />
            <p className="mt-1 mb-4">Forward10</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Forward30 />
            <p className="mt-1 mb-4">Forward30</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Forward5 />
            <p className="mt-1 mb-4">Forward5</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Games />
            <p className="mt-1 mb-4">Games</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Hd />
            <p className="mt-1 mb-4">Hd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Hearing />
            <p className="mt-1 mb-4">Hearing</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <HighQuality />
            <p className="mt-1 mb-4">HighQuality</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LibraryAdd />
            <p className="mt-1 mb-4">LibraryAdd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LibraryBooks />
            <p className="mt-1 mb-4">LibraryBooks</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LibraryMusic />
            <p className="mt-1 mb-4">LibraryMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Loop />
            <p className="mt-1 mb-4">Loop</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Mic />
            <p className="mt-1 mb-4">Mic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <MicNone />
            <p className="mt-1 mb-4">MicNone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <MicOff />
            <p className="mt-1 mb-4">MicOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Movie />
            <p className="mt-1 mb-4">Movie</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <MusicVideo />
            <p className="mt-1 mb-4">MusicVideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <NewReleases />
            <p className="mt-1 mb-4">NewReleases</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RepeatOne />
            <p className="mt-1 mb-4">RepeatOne</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Replay />
            <p className="mt-1 mb-4">Replay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Replay5 />
            <p className="mt-1 mb-4">Replay5</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Shuffle />
            <p className="mt-1 mb-4">Shuffle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SkipNext />
            <p className="mt-1 mb-4">SkipNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SkipPrevious />
            <p className="mt-1 mb-4">SkipPrevious</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Schedule />
            <p className="mt-1 mb-4">Schedule</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TabUnselected />
            <p className="mt-1 mb-4">TabUnselected</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Tab />
            <p className="mt-1 mb-4">Tab</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SystemUpdateAlt />
            <p className="mt-1 mb-4">SystemUpdateAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapVerticalCircle />
            <p className="mt-1 mb-4">SwapVerticalCircle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <VerifiedUser />
            <p className="mt-1 mb-4">VerifiedUser</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Update />
            <p className="mt-1 mb-4">Update</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TurnedInNot />
            <p className="mt-1 mb-4">TurnedInNot</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TurnedIn />
            <p className="mt-1 mb-4">TurnedIn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Alarm />
            <p className="mt-1 mb-4">Alarm</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddShoppingCart />
            <p className="mt-1 mb-4">AddShoppingCart</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AccountCircle />
            <p className="mt-1 mb-4">AccountCircle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AccountBox />
            <p className="mt-1 mb-4">AccountBox</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AccountBalanceWallet />
            <p className="mt-1 mb-4">AccountBalanceWallet</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AccountBalance />
            <p className="mt-1 mb-4">AccountBalance</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Accessible />
            <p className="mt-1 mb-4">Accessible</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Accessibility />
            <p className="mt-1 mb-4">Accessibility</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThreeDRotation />
            <p className="mt-1 mb-4">ThreeDRotation</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CallToAction />
            <p className="mt-1 mb-4">CallToAction</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <BrandingWatermark />
            <p className="mt-1 mb-4">BrandingWatermark</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AvTimer />
            <p className="mt-1 mb-4">AvTimer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ArtTrack />
            <p className="mt-1 mb-4">ArtTrack</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Album />
            <p className="mt-1 mb-4">Album</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Airplay />
            <p className="mt-1 mb-4">Airplay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddToQueue />
            <p className="mt-1 mb-4">AddToQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Explicit />
            <p className="mt-1 mb-4">Explicit</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FastForward />
            <p className="mt-1 mb-4">FastForward</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturned />
            <p className="mt-1 mb-4">AssignmentReturned</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentTurnedIn />
            <p className="mt-1 mb-4">AssignmentTurnedIn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Autorenew />
            <p className="mt-1 mb-4">Autorenew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Backup />
            <p className="mt-1 mb-4">Backup</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Book />
            <p className="mt-1 mb-4">Book</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Bookmark />
            <p className="mt-1 mb-4">Bookmark</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <EuroSymbol />
            <p className="mt-1 mb-4">EuroSymbol</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Event />
            <p className="mt-1 mb-4">Event</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <EventSeat />
            <p className="mt-1 mb-4">EventSeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ExitToApp />
            <p className="mt-1 mb-4">ExitToApp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Explore />
            <p className="mt-1 mb-4">Explore</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Extension />
            <p className="mt-1 mb-4">Extension</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Face />
            <p className="mt-1 mb-4">Face</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Favorite />
            <p className="mt-1 mb-4">Favorite</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FavoriteBorder />
            <p className="mt-1 mb-4">FavoriteBorder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <BookmarkBorder />
            <p className="mt-1 mb-4">BookmarkBorder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <BugReport />
            <p className="mt-1 mb-4">BugReport</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Build />
            <p className="mt-1 mb-4">Build</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Cached />
            <p className="mt-1 mb-4">Cached</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CameraEnhance />
            <p className="mt-1 mb-4">CameraEnhance</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CardGiftcard />
            <p className="mt-1 mb-4">CardGiftcard</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CardMembership />
            <p className="mt-1 mb-4">CardMembership</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <CardTravel />
            <p className="mt-1 mb-4">CardTravel</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ChangeHistory />
            <p className="mt-1 mb-4">ChangeHistory</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Delete />
            <p className="mt-1 mb-4">Delete</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DeleteForever />
            <p className="mt-1 mb-4">DeleteForever</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Description />
            <p className="mt-1 mb-4">Description</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Dns />
            <p className="mt-1 mb-4">Dns</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Done />
            <p className="mt-1 mb-4">Done</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DoneAll />
            <p className="mt-1 mb-4">DoneAll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DonutLarge />
            <p className="mt-1 mb-4">DonutLarge</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <DonutSmall />
            <p className="mt-1 mb-4">DonutSmall</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Eject />
            <p className="mt-1 mb-4">Eject</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <GTranslate />
            <p className="mt-1 mb-4">GTranslate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Feedback />
            <p className="mt-1 mb-4">Feedback</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FindInPage />
            <p className="mt-1 mb-4">FindInPage</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FindReplace />
            <p className="mt-1 mb-4">FindReplace</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Fingerprint />
            <p className="mt-1 mb-4">Fingerprint</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FlightLand />
            <p className="mt-1 mb-4">FlightLand</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FlightTakeoff />
            <p className="mt-1 mb-4">FlightTakeoff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FlipToBack />
            <p className="mt-1 mb-4">FlipToBack</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FlipToFront />
            <p className="mt-1 mb-4">FlipToFront</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Gavel />
            <p className="mt-1 mb-4">Gavel</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <GetApp />
            <p className="mt-1 mb-4">GetApp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Gif />
            <p className="mt-1 mb-4">Gif</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Grade />
            <p className="mt-1 mb-4">Grade</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <GroupWork />
            <p className="mt-1 mb-4">GroupWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Help />
            <p className="mt-1 mb-4">Help</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <HelpOutline />
            <p className="mt-1 mb-4">HelpOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <HighlightOff />
            <p className="mt-1 mb-4">HighlightOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <History />
            <p className="mt-1 mb-4">History</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Redeem />
            <p className="mt-1 mb-4">Redeem</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecordVoiceOver />
            <p className="mt-1 mb-4">RecordVoiceOver</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Receipt />
            <p className="mt-1 mb-4">Receipt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Equalizer />
            <p className="mt-1 mb-4">Equalizer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ClosedCaption />
            <p className="mt-1 mb-4">ClosedCaption</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberPin />
            <p className="mt-1 mb-4">FiberPin</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberNew />
            <p className="mt-1 mb-4">FiberNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberManualRecord />
            <p className="mt-1 mb-4">FiberManualRecord</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FiberDvr />
            <p className="mt-1 mb-4">FiberDvr</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenInBrowser />
            <p className="mt-1 mb-4">OpenInBrowser</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenInNew />
            <p className="mt-1 mb-4">OpenInNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OpenWith />
            <p className="mt-1 mb-4">OpenWith</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pageview />
            <p className="mt-1 mb-4">Pageview</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PanTool />
            <p className="mt-1 mb-4">PanTool</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Payment />
            <p className="mt-1 mb-4">Payment</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermCameraMic />
            <p className="mt-1 mb-4">PermCameraMic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermContactCalendar />
            <p className="mt-1 mb-4">PermContactCalendar</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermDataSetting />
            <p className="mt-1 mb-4">PermDataSetting</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <List />
            <p className="mt-1 mb-4">List</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LineWeight />
            <p className="mt-1 mb-4">LineWeight</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LineStyle />
            <p className="mt-1 mb-4">LineStyle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LightbulbOutline />
            <p className="mt-1 mb-4">LightbulbOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Launch />
            <p className="mt-1 mb-4">Launch</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Language />
            <p className="mt-1 mb-4">Language</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LabelOutline />
            <p className="mt-1 mb-4">LabelOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Label />
            <p className="mt-1 mb-4">Label</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <InvertColors />
            <p className="mt-1 mb-4">InvertColors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Input />
            <p className="mt-1 mb-4">Input</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <InfoOutline />
            <p className="mt-1 mb-4">InfoOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Info />
            <p className="mt-1 mb-4">Info</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ImportantDevices />
            <p className="mt-1 mb-4">ImportantDevices</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Https />
            <p className="mt-1 mb-4">Https</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Http />
            <p className="mt-1 mb-4">Http</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <HourglassFull />
            <p className="mt-1 mb-4">HourglassFull</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <HourglassEmpty />
            <p className="mt-1 mb-4">HourglassEmpty</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Home />
            <p className="mt-1 mb-4">Home</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermDeviceInformation />
            <p className="mt-1 mb-4">PermDeviceInformation</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Lock />
            <p className="mt-1 mb-4">Lock</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LockOpen />
            <p className="mt-1 mb-4">LockOpen</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <LockOutline />
            <p className="mt-1 mb-4">LockOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Loyalty />
            <p className="mt-1 mb-4">Loyalty</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <MarkunreadMailbox />
            <p className="mt-1 mb-4">MarkunreadMailbox</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Motorcycle />
            <p className="mt-1 mb-4">Motorcycle</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <NoteAdd />
            <p className="mt-1 mb-4">NoteAdd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <OfflinePin />
            <p className="mt-1 mb-4">OfflinePin</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Opacity />
            <p className="mt-1 mb-4">Opacity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueryBuilder />
            <p className="mt-1 mb-4">QueryBuilder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Print />
            <p className="mt-1 mb-4">Print</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PregnantWoman />
            <p className="mt-1 mb-4">PregnantWoman</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PowerSettingsNew />
            <p className="mt-1 mb-4">PowerSettingsNew</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Polymer />
            <p className="mt-1 mb-4">Polymer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AddAlert />
            <p className="mt-1 mb-4">AddAlert</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QuestionAnswer />
            <p className="mt-1 mb-4">QuestionAnswer</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermIdentity />
            <p className="mt-1 mb-4">PermIdentity</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermMedia />
            <p className="mt-1 mb-4">PermMedia</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermPhoneMsg />
            <p className="mt-1 mb-4">PermPhoneMsg</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PermScanWifi />
            <p className="mt-1 mb-4">PermScanWifi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Pets />
            <p className="mt-1 mb-4">Pets</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPicture />
            <p className="mt-1 mb-4">PictureInPicture</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PictureInPictureAlt />
            <p className="mt-1 mb-4">PictureInPictureAlt</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlayForWork />
            <p className="mt-1 mb-4">PlayForWork</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveShoppingCart />
            <p className="mt-1 mb-4">RemoveShoppingCart</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Reorder />
            <p className="mt-1 mb-4">Reorder</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ReportProblem />
            <p className="mt-1 mb-4">ReportProblem</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Restore />
            <p className="mt-1 mb-4">Restore</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RestorePage />
            <p className="mt-1 mb-4">RestorePage</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Room />
            <p className="mt-1 mb-4">Room</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RoundedCorner />
            <p className="mt-1 mb-4">RoundedCorner</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Rowing />
            <p className="mt-1 mb-4">Rowing</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FastRewind />
            <p className="mt-1 mb-4">FastRewind</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FeaturedPlayList />
            <p className="mt-1 mb-4">FeaturedPlayList</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <FeaturedVideo />
            <p className="mt-1 mb-4">FeaturedVideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsVoice />
            <p className="mt-1 mb-4">SettingsVoice</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsRemote />
            <p className="mt-1 mb-4">SettingsRemote</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsPower />
            <p className="mt-1 mb-4">SettingsPower</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsPhone />
            <p className="mt-1 mb-4">SettingsPhone</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsOverscan />
            <p className="mt-1 mb-4">SettingsOverscan</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputSvideo />
            <p className="mt-1 mb-4">SettingsInputSvideo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputHdmi />
            <p className="mt-1 mb-4">SettingsInputHdmi</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputComposite />
            <p className="mt-1 mb-4">SettingsInputComposite</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputComponent />
            <p className="mt-1 mb-4">SettingsInputComponent</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stars />
            <p className="mt-1 mb-4">Stars</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Spellcheck />
            <p className="mt-1 mb-4">Spellcheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SpeakerNotesOff />
            <p className="mt-1 mb-4">SpeakerNotesOff</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SpeakerNotes />
            <p className="mt-1 mb-4">SpeakerNotes</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShoppingCart />
            <p className="mt-1 mb-4">ShoppingCart</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShoppingBasket />
            <p className="mt-1 mb-4">ShoppingBasket</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ShopTwo />
            <p className="mt-1 mb-4">ShopTwo</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Shop />
            <p className="mt-1 mb-4">Shop</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsInputAntenna />
            <p className="mt-1 mb-4">SettingsInputAntenna</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsEthernet />
            <p className="mt-1 mb-4">SettingsEthernet</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsCell />
            <p className="mt-1 mb-4">SettingsCell</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBrightness />
            <p className="mt-1 mb-4">SettingsBrightness</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBluetooth />
            <p className="mt-1 mb-4">SettingsBluetooth</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsBackupRestore />
            <p className="mt-1 mb-4">SettingsBackupRestore</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SettingsApplications />
            <p className="mt-1 mb-4">SettingsApplications</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Settings />
            <p className="mt-1 mb-4">Settings</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <search />
            <p className="mt-1 mb-4">search</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewAgenda />
            <p className="mt-1 mb-4">ViewAgenda</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingUp />
            <p className="mt-1 mb-4">TrendingUp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingFlat />
            <p className="mt-1 mb-4">TrendingFlat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrendingDown />
            <p className="mt-1 mb-4">TrendingDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Translate />
            <p className="mt-1 mb-4">Translate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TrackChanges />
            <p className="mt-1 mb-4">TrackChanges</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Warning />
            <p className="mt-1 mb-4">Warning</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ErrorOutline />
            <p className="mt-1 mb-4">ErrorOutline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Error />
            <p className="mt-1 mb-4">Error</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <TouchApp />
            <p className="mt-1 mb-4">TouchApp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Toll />
            <p className="mt-1 mb-4">Toll</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Today />
            <p className="mt-1 mb-4">Today</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Toc />
            <p className="mt-1 mb-4">Toc</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Timeline />
            <p className="mt-1 mb-4">Timeline</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbsUpDown />
            <p className="mt-1 mb-4">ThumbsUpDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Repeat />
            <p className="mt-1 mb-4">Repeat</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RemoveFromQueue />
            <p className="mt-1 mb-4">RemoveFromQueue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <RecentActors />
            <p className="mt-1 mb-4">RecentActors</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Radio />
            <p className="mt-1 mb-4">Radio</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueuePlayNext />
            <p className="mt-1 mb-4">QueuePlayNext</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <QueueMusic />
            <p className="mt-1 mb-4">QueueMusic</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Queue />
            <p className="mt-1 mb-4">Queue</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistPlay />
            <p className="mt-1 mb-4">PlaylistPlay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <PlaylistAddCheck />
            <p className="mt-1 mb-4">PlaylistAddCheck</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentInd />
            <p className="mt-1 mb-4">AssignmentInd</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentLate />
            <p className="mt-1 mb-4">AssignmentLate</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <AssignmentReturn />
            <p className="mt-1 mb-4">AssignmentReturn</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbUp />
            <p className="mt-1 mb-4">ThumbUp</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ThumbDown />
            <p className="mt-1 mb-4">ThumbDown</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Theaters />
            <p className="mt-1 mb-4">Theaters</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapVert />
            <p className="mt-1 mb-4">SwapVert</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SwapHoriz />
            <p className="mt-1 mb-4">SwapHoriz</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SupervisorAccount />
            <p className="mt-1 mb-4">SupervisorAccount</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Subject />
            <p className="mt-1 mb-4">Subject</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Store />
            <p className="mt-1 mb-4">Store</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewDay />
            <p className="mt-1 mb-4">ViewDay</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <ViewColumn />
            <p className="mt-1 mb-4">ViewColumn</p>
        </div>

    </div>
);
export default Icons;



// WEBPACK FOOTER //
// ./app/routes/icons/routes/Material/Icons.js